var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleAnchorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67405 11.0536L4.94839 11.3232L5.22273 11.0536L8.27841 8.05111C10.0344 6.32563 10.0344 3.52809 8.27841 1.80262C6.52239 0.0771432 3.67531 0.0771401 1.91929 1.80261L1.84405 1.87654C0.0464811 3.64284 0.0464818 6.50658 1.84406 8.27288L4.67405 11.0536Z",
    fill: "#68159A",
    stroke: "white",
    strokeWidth: 0.769231
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06533 0.889893C4.02511 0.898226 2.98749 1.29233 2.19381 2.0722L2.11858 2.14613C0.472518 3.76355 0.472518 6.38591 2.11858 8.00333L4.94857 10.7841L5.06533 10.6694V0.889893Z",
    fill: "#9B29E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1054:14257)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.05,
    cy: 3.15303,
    r: 0.801282,
    stroke: "white",
    strokeWidth: 0.600962
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79639 6.00757V6.45829C3.0134 6.89232 3.76794 7.76037 5.04999 7.76037",
    stroke: "white",
    strokeWidth: 0.600962,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30371 6.00757V6.45829C7.0867 6.89232 6.33216 7.76037 5.05011 7.76037",
    stroke: "white",
    strokeWidth: 0.600962,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.04999,
    y1: 4.25483,
    x2: 5.04999,
    y2: 8.16108,
    stroke: "white",
    strokeWidth: 0.600962,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.85137,
    y1: 5.25654,
    x2: 4.24881,
    y2: 5.25654,
    stroke: "white",
    strokeWidth: 0.600962,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1054:14257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.41026,
    height: 6.41026,
    fill: "white",
    transform: "translate(1.79492 2.05127)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleAnchorIcon);
export default __webpack_public_path__ + "static/media/purple-anchor-icon.2bda926d7b89447f6551dd43ee8dc6bb.svg";
export { ForwardRef as ReactComponent };